import React from "react";
import adjustments from "./assets/adjustments.xlsx";

const Changes = () => {
  return (
    <div className="welcome-page-2">
      <div className="faq-page-wrapper">
        <header>
          <h1>FAQs: Anpassungen & Änderungen</h1>
        </header>
        <p>
          Da es in der EDEKA-Welt verschiedene Systeme gibt, ist es wichtig,
          dass überall die gleichen Daten von euch hinterlegt sind, um einen
          Datenschiefstand zu vermeiden. Daher benötigen wir bitte bei
          sämtlichen Änderungen eurerseits eine Info per Mail, damit wir in
          allen Systemen eine Anpassung vornehmen können. Nachfolgend ist kurz
          aufgelistet, was ihr in welchen Fällen tun müsst. Zudem findet ihr
          eine Excel-Datei, welche ihr uns bitte ausgefüllt an
          info@starthub.edeka zuschicken müsst, sodass wir eure Änderungen
          verarbeiten können.
        </p>
        <p>
          <strong>
            Wie gehe ich vor, wenn es bei meinem Produkt zu Preisänderungen
            kommt?{" "}
          </strong>
          <br />
          <strong>Preissenkungen </strong> sind generell immer möglich (sofern
          die Handelsspanne im gewünschten Bereich bleibt) und müssen uns bitte
          unter Angabe der GTIN per Mail mitgeteilt werden. Bis die Anpassung in
          allen Regionen durchgeführt wurde und wir diese auch auf unserer
          Plattform vornehmen können, dauert es jedoch vier Wochen.
          <br />
          <strong>Preiserhöhungen</strong> müssen erneut vom Einkauf geprüft
          werden. Diese Prüfung findet wöchentlich mit einer begrenzten Anzahl
          an Produkten statt, weshalb es hier zu einigen Wochen Wartezeit kommen
          kann. Erst wenn diese Prüfung positiv ausfällt, können die Anpassungen
          vorgenommen werden, was ebenfalls, wie bei Preissenkungen, vier Wochen
          dauert.
        </p>
        <p>
          <strong>
            Wie gehe ich vor, wenn es bei meinem Unternehmen zu einer
            Umfirmierung kommt?
          </strong>
          <br />
          In einem solchen Fall benötigen wir ein offizielles Schreiben (mit
          neuem Briefkopf), was die Umfirmierung bestätigt. Wir benötigen eine
          Info, ob die angegebene GLN weiter genutzt wird oder nicht. Wenn es zu
          einer Rechtsform-Änderung kam, brauchen wir zudem eine Bestätigung des
          Antrags im Handelsregister.
        </p>
        <p>
          <strong>Wie gehe ich bei GTIN- und Artikeländerungen vor?</strong>
          <br />
          Wir benötigen genaue Informationen, welche Produkte betroffen sind
          sowie eine Auflistung der alten und neuen Daten. Bei GTIN-Änderungen
          des Einzelartikels, benötigen wir auch eine neue GTIN für die
          Versandeinheit.
        </p>
        <a
          className="download-link"
          download="foodstarter_template-anderungen.xlsx"
          href={adjustments}
        >
          Download Datei zu Anpassungen
        </a>
      </div>
    </div>
  );
};

export default Changes;
